module.exports = __webpack_public_path__ + "img/palmas-restaurant.f294a398.jpg";